import React, { useState, useEffect } from 'react';
import { validateAscii, NOTES_MAX_LENGTH } from '../../craexports/userNotes';

const UserNotes = (props) => {
    const [maxLength] = useState(NOTES_MAX_LENGTH);
    const [notesValue, setNotesValue] = useState(props.userNotes || '');
    const [placeholder] = useState('Optional');
    const [isValidCharacter, setIsValidCharacter] = useState(true);

    const notesStyle = props.notesStyle || { resize: "vertical" };
    const notesLabelStyle = props.notesLabelStyle || {};

    const handleSetUserNotes = (val) => {
        if (val.length > maxLength) return;

        setNotesValue(val);
        if (props.setUserNotes) {
            props.setUserNotes(val);
        }
    };

    const handleKeyPress = (e) => {
        if (!validateAscii(e.key, maxLength) || e.target.value.length + 1 > (maxLength || Infinity)) {
            setIsValidCharacter(false);
            e.preventDefault();
            return false;
        }
        setIsValidCharacter(true);
    };

    const handlePaste = (e) => {
        const paste = (e.clipboardData || window.clipboardData).getData('Text');

        if (!validateAscii(paste, maxLength) || paste.length > (maxLength || Infinity)) {
            setIsValidCharacter(false);
            e.preventDefault();
            return false;
        }

        setIsValidCharacter(true);
    };

    return (
        <React.Fragment>
            <textarea
                id='userNotes'
                className="form-control"
                type='text'
                style={notesStyle}
                value={notesValue}
                placeholder={placeholder}
                maxLength={maxLength}
                onChange={e => handleSetUserNotes(e.target.value)}
                onKeyPress={handleKeyPress}
                onPaste={handlePaste}
            />
            <label htmlFor="userNotes" style={notesLabelStyle}>{`${maxLength - notesValue.length} characters remaining`}</label>
            {!isValidCharacter &&
                <div>
                    <label>No special characters allowed</label>
                </div>
            }
        </React.Fragment>
    );
};

export default UserNotes;